import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import * as XLSX from 'xlsx';
import { FormBuilder, FormGroup, FormArray, Validators } from "@angular/forms";



@Component({
  selector: 'app-excel-import',
  templateUrl: './excel-import.component.html',
  styleUrl: './excel-import.component.css'
})
export class ExcelImportComponent {
  importForm: FormGroup;

  rowData: any[] = [];
  columnDefs: any[] = [];

  defaultColDef = { editable: true, resizable: true, sortable: true, filter: true };

  type: any
  typeC: any
  userD: any;
  organizationId: any;
  branchId: any;
  branchList: any[] = [];
  branchShow: boolean;
  orgname: any;

  /**
   * Per-row import results returned by POST /api/transactions/import. We
   * surface these in the UI so users can see exactly which row failed and
   * why (e.g. "No active subscription with user limit found").
   */
  importResult: {
    success: boolean;
    message: string;
    summary?: { totalRows: number; successful: number; failed: number; duplicates: number };
    failedRecords: Array<{ row: number; data: any; error: string }>;
    duplicateRecords: Array<{ row: number; data: any; reason?: string }>;
  } | null = null;

  importing = false;

  impTypes = ['Branch', 'Projects', 'User', 'Employee', 'Materials', 'Machine'];
  constructor(
    private readonly apiService: ApiService,
    private router: Router,
    private readonly toastrMsgService: ToastrMsgService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,

  ) {
    this.importForm = this.formBuilder.group({
      branchId: [""],
      improle: ["", Validators.required],
    })
  }
  ngOnInit() {
    const user = localStorage.getItem('user') as any;
    this.userD = JSON.parse(user);
    this.orgname = this.userD.user.org_name
    this.organizationId = this.userD.user.org_id;
    
    this.fetchBranchList()
    this.route.params.subscribe((params) => {
      this.type = params['type'];
    });
    this.importForm.patchValue({
      improle: this.type
    })
    if (this.type == 'User') {
      this.typeC = 'user'
    } else if (this.type == 'Project') {
      this.typeC = 'project'
    } else if (this.type == 'Staff') {
      this.typeC = 'staff'
    } else if (this.type == 'Employee') {
      this.typeC = 'staff'
    } else if (this.type == 'Branch') {
      this.typeC = 'Branch'
    } else if (this.type == 'Material') {
      this.typeC = 'material'
    }
    else if (this.type == 'Machine') {
      this.typeC = 'machine'
    }
  }
  onFileChange(event: any) {
    console.log('event75', event);
    const file = event.target.files[0];
    
    if (!file) {
      return;
    }

    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    const reader = new FileReader();

    reader.onload = (e: any) => {
      try {
        let workbook: XLSX.WorkBook;
        const data = e.target.result;

        // Handle CSV files differently
        if (fileExtension === 'csv') {
          // For CSV, read as text and let XLSX parse it
          workbook = XLSX.read(data, { 
            type: 'string', 
            raw: false
          });
        } else {
          // For Excel files (.xlsx, .xls)
          workbook = XLSX.read(data, { type: 'binary', cellDates: true });
        }

        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        
        // Convert sheet to JSON with proper header handling
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { 
          header: 1, // Get data as array of arrays first
          defval: '',
          raw: false
        }) as any[][];

        console.log('Raw data from file:', jsonData);

        if (jsonData.length === 0) {
          this.toastrMsgService.error('The file is empty or has no valid data');
          return;
        }

        // Extract headers from first row
        const headers = jsonData[0];
        
        if (!headers || headers.length === 0) {
          this.toastrMsgService.error('No headers found in the file');
          return;
        }

        // Convert remaining rows to objects using headers
        const dataRows = jsonData.slice(1).filter(row => {
          // Filter out empty rows
          return row.some(cell => cell !== null && cell !== undefined && cell !== '');
        });

        if (dataRows.length === 0) {
          this.toastrMsgService.error('No data rows found in the file');
          return;
        }

        // Map data rows to objects with proper headers
        const mappedData = dataRows.map(row => {
          const obj: any = {};
          headers.forEach((header: any, index: number) => {
            // Use header as key, or create a generic key if header is empty
            const key = header && header.toString().trim() ? header.toString().trim() : `Column_${index + 1}`;
            obj[key] = row[index] !== undefined && row[index] !== null ? row[index] : '';
          });
          return obj;
        });

        console.log('Mapped data:', mappedData);
        console.log('Headers:', headers);

        this.rowData = this.processDateColumns(mappedData);
        this.columnDefs = this.generateColumnDefs(mappedData);
        
        console.log('CSV/Excel data loaded:', {
          totalRows: this.rowData.length,
          columns: this.columnDefs.length,
          fileType: fileExtension,
          headers: headers
        });
        
        this.toastrMsgService.success(`Successfully loaded ${this.rowData.length} rows from ${fileExtension?.toUpperCase()} file`);
      } catch (error) {
        console.error('Error reading file:', error);
        this.toastrMsgService.error('Error reading file. Please ensure it is a valid Excel or CSV file.');
        this.rowData = [];
        this.columnDefs = [];
      }
    };

    reader.onerror = (error) => {
      console.error('File reading error:', error);
      this.toastrMsgService.error('Failed to read the file');
    };

    // Read file based on extension
    if (fileExtension === 'csv') {
      reader.readAsText(file);
    } else {
      reader.readAsBinaryString(file);
    }
  }
  processDateColumns(data: any[]): any[] {
    return data.map(row => {
      const newRow: any = { ...row };
      for (const key in row) {
        if (this.isDateString(row[key])) {
          newRow[key] = new Date(row[key]);
        }
      }
      return newRow;
    });
  }

  isDateString(value: any): boolean {
    // Detect ISO or slash-based dates (basic)
    return typeof value === 'string' &&
      (/\d{4}-\d{2}-\d{2}/.test(value) || /\d{2}\/\d{2}\/\d{4}/.test(value));
  }
  generateColumnDefs(data: any[]): any[] {
    if (!data || data.length === 0) return [];

    const firstRow = data[0];
    return Object.keys(firstRow).map(key => {
      const isDateCol = data.some(row => row[key] instanceof Date);

      return {
        headerName: key,
        field: key,
        filter: isDateCol ? 'agDateColumnFilter' : true,
        valueFormatter: isDateCol
          ? (params: any) => this.dateFormatter(params.value)
          : undefined,
      };
    });
  }

  dateFormatter(value: any): string {
    if (!value) return '';
    const date = new Date(value);
    return date.toLocaleDateString('en-GB'); // or use DatePipe
  }

  fetchBranchList() {
    this.apiService.getOrganizationsBranch(this.organizationId).subscribe({
      next: (res: any) => {
        console.log('API Response:', res);
        if (res.data.length != 0) {
          this.branchList = res.data
          this.branchShow = true

        } else {
          this.branchId = this.userD.user.org_id;
          this.importForm.get('branchId')?.setValue(this.branchId);
          this.branchShow = false
        }


      },
      error: (err) => {
        console.log('API Error:', err);
        this.toastrMsgService.error(err.error.message);
      },
      complete: () => console.log('Observable complete'),
    });
  }

  downloadTemplate() {
    const importType = this.importForm.get('improle')?.value || this.type;
    
    if (!importType) {
      this.toastrMsgService.warning('Please select an import type first');
      return;
    }

    // Check if template is available for this type
    const typesWithTemplates = ['Project', 'Projects', 'Staff', 'Employee', 'Material', 'Materials', 'Machine', 'Machines'];
    if (!typesWithTemplates.includes(importType)) {
      this.toastrMsgService.warning(`Template not available for ${importType}`);
      return;
    }

    this.apiService.downloadTemplate(importType).subscribe({
      next: (blob: Blob) => {
        // Create a blob URL and trigger download
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        
        // Determine filename based on import type
        const filenameMap: { [key: string]: string } = {
          'Project': 'project_import_template_with_data.xlsx',
          'Projects': 'project_import_template_with_data.xlsx',
          'Staff': 'staff_import_template_working.xlsx',
          'Employee': 'staff_import_template_working.xlsx',
          'Material': 'material_template_working.xlsx',
          'Materials': 'material_template_working.xlsx',
          'Machine': 'machine_template_working.xlsx',
          'Machines': 'machine_template_working.xlsx'
        };
        
        const filename = filenameMap[importType] || `${importType}_template.xlsx`;
        
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        this.toastrMsgService.success('Template downloaded successfully');
      },
      error: (err: any) => {
        console.error('Error downloading template:', err);
        if (err.error instanceof Blob) {
          // Try to parse error message from blob
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errorObj = JSON.parse(reader.result as string);
              this.toastrMsgService.error(errorObj.message || errorObj.error || 'Failed to download template');
            } catch {
              this.toastrMsgService.error('Failed to download template');
            }
          };
          reader.readAsText(err.error);
        } else {
          this.toastrMsgService.error(err.error?.message || err.error?.error || 'Failed to download template');
        }
      }
    });
  }

  saveChanges() {
    console.log('Updated Data:', this.rowData);
    const params = { type: this.typeC, file: this.rowData };

    this.importing = true;
    this.importResult = null;

    this.apiService.addImport(params).subscribe({
      next: (res: any) => {
        this.importing = false;
        this.applyImportResult(res);

        const summary = res?.summary || {};
        const successful = Number(summary.successful || 0);
        const failed = Number(summary.failed || 0);
        const duplicates = Number(summary.duplicates || 0);
        const total = Number(summary.totalRows || this.rowData.length || 0);

        if (res?.success && failed === 0 && duplicates === 0) {
          this.toastrMsgService.success(res?.message || `Imported ${successful}/${total} rows`);
          this.navigateAfterImport();
          return;
        }

        if (successful > 0 && (failed > 0 || duplicates > 0)) {
          this.toastrMsgService.warning(
            `Imported ${successful}/${total}. ${failed} failed, ${duplicates} duplicates — see details below.`
          );
          return;
        }

        const primaryReason =
          this.getPrimaryFailureReason(res) ||
          res?.message ||
          'All records failed to import';
        this.toastrMsgService.error(primaryReason);
      },
      error: (err) => {
        this.importing = false;
        console.log(err);
        this.applyImportResult(err?.error);
        const reason =
          this.getPrimaryFailureReason(err?.error) ||
          err?.error?.message ||
          err?.error?.error ||
          'Failed to import data';
        this.toastrMsgService.error(reason);
      },
      complete: () => console.log('Observable complete'),
    });
  }

  /** Normalize the server response into a UI-friendly result. */
  private applyImportResult(res: any): void {
    if (!res) {
      this.importResult = null;
      return;
    }
    const details = res.details || {};
    const failedRecords = Array.isArray(details.failedRecords) ? details.failedRecords : [];
    const duplicateRecords = Array.isArray(details.duplicateRecords) ? details.duplicateRecords : [];
    this.importResult = {
      success: !!res.success,
      message: res.message || '',
      summary: res.summary || undefined,
      failedRecords,
      duplicateRecords,
    };
  }

  /** Pick the most representative failure reason for a toast/header. */
  private getPrimaryFailureReason(res: any): string | null {
    const failed = res?.details?.failedRecords;
    if (!Array.isArray(failed) || failed.length === 0) return null;
    const counts = new Map<string, number>();
    for (const f of failed) {
      const key = (f?.error || '').toString().trim();
      if (!key) continue;
      counts.set(key, (counts.get(key) || 0) + 1);
    }
    let top: { msg: string; n: number } | null = null;
    for (const [msg, n] of counts.entries()) {
      if (!top || n > top.n) top = { msg, n };
    }
    return top?.msg || null;
  }

  /** Best-effort label for a failed row (email/name/etc). */
  failedRowLabel(record: { data: any }): string {
    const d = record?.data || {};
    return (
      d.contact_email ||
      d.email_id ||
      d.email ||
      d.full_name ||
      d.name ||
      d.project_name ||
      d.org_name ||
      ''
    );
  }

  /** Clear the failed/duplicate panels so the user can retry cleanly. */
  clearImportResult(): void {
    this.importResult = null;
  }

  private navigateAfterImport(): void {
    if (this.type == 'User') {
      this.router.navigate(['home/user']);
    } else if (this.type == 'Project') {
      this.router.navigate(['home/projects']);
    } else if (this.type == 'Staff' || this.type == 'Employee') {
      this.router.navigate(['home/employees']);
    } else if (this.type == 'Branch') {
      this.router.navigate(['home/company']);
    } else if (this.type == 'Material') {
      this.router.navigate(['home/material-list']);
    } else if (this.type == 'Machine') {
      this.router.navigate(['home/machine-master']);
    }
  }
}
